/**
 * Wavedash SDK bridge (offline no-op when window.Wavedash missing).
 */
export const ht = () => typeof window < `u` && window.Wavedash || null;
export async function gt(e, t, n) {
    let r = ht();
    if (!r) return t;
    try {
        return await n(r)
    } catch (n) {
        return console.warn(`[wavedash] ${e} failed`, n), t
    }
}
export const _t = 8e3;
export const B = new class {
        initialized = !1;
        presenceSent = ``;
        presenceWanted = ``;
        presenceTimer = 0;
        get online() {
            return ht() !== null
        }
        progress(e) {
            gt(`progress`, void 0, t => t.updateLoadProgressZeroToOne(Math.max(0, Math.min(1, e))))
        }
        ready() {
            gt(`init`, void 0, e => {
                e.init({
                    debug: !1
                }), e.loadComplete(), this.initialized = !0, this.presence(this.presenceWanted)
            })
        }
        playerName() {
            let e = ht();
            try {
                return e?.getUser()?.username || e?.getUsername() || `you`
            } catch {
                return `you`
            }
        }
        shareScreenshot(e, t, n) {
            return gt(`screenshot`, !1, async r => {
                let i = `afters/snapshots/${Date.now()}.png`;
                return await r.writeLocalFile(i, e) ? (await r.createUGCItem(r.UGCType.SCREENSHOT, t, n, r.UGCVisibility.PUBLIC, i)).success : !1
            })
        }
        presence(e) {
            let t = ht();
            if (this.presenceWanted = e, !t || !e || !this.initialized || this.presenceTimer) return;
            let n = () => {
                this.presenceTimer = 0, this.presenceWanted !== this.presenceSent && (this.presenceSent = this.presenceWanted, t.updateUserPresence({
                    status: this.presenceSent
                }).catch(() => void 0), this.presenceTimer = window.setTimeout(n, _t))
            };
            n()
        }
        async toggleFullscreen() {
            if (typeof ht()?.toggleFullscreen == `function`) {
                await gt(`fullscreen`, !1, e => e.toggleFullscreen());
                return
            }
            try {
                document.fullscreenElement ? await document.exitFullscreen() : await document.documentElement.requestFullscreen()
            } catch {}
        }
        toggleMute() {
            return gt(`mute`, !1, async e => typeof e.toggleMute == `function` && e.toggleMute())
        }
};

export { B as wavedash };
